var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangeDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Exchange_Device"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exchange_Device",
    "data-name": "Exchange Device",
    clipPath: "url(#clip-Exchange_Device)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exchange_device-2",
    "data-name": "Exchange device",
    d: "M41,25v78H471V25ZM295,48h18V80H295Zm121,0a16,16,0,1,1-16,16A16,16,0,0,1,416,48ZM64,55h48V73H64Zm80,0h48V73H144Zm80,0h48V73H224ZM105,121v30H407V121ZM41,169v78H471V169Zm254,23h18v32H295Zm121,0a16,16,0,1,1-16,16A16,16,0,0,1,416,192ZM64,199h48v18H64Zm80,0h48v18H144Zm80,0h48v18H224ZM105,265v30H407V265ZM41,313v78H471V313Zm254,23h18v32H295Zm121,0a16,16,0,1,1-16,16A16,16,0,0,1,416,336ZM64,343h48v18H64Zm80,0h48v18H144Zm80,0h48v18H224Zm13,66v30h38V409ZM25,457v30H155.2l20-30Zm171.8,0-20,30H335.2l-20-30Zm140,0,20,30H487V457Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeDevice);
export default __webpack_public_path__ + "static/media/Exchange Device.878024f2b6d24462b645f4aa98a8ab12.svg";
export { ForwardRef as ReactComponent };